import { Injectable } from '@angular/core';
import { PhoneNumberUtil, PhoneNumberFormat, PhoneNumberType } from 'google-libphonenumber';

@Injectable({
  providedIn: 'root',
})
export class PhoneValidatorService {
  phoneUtil = PhoneNumberUtil.getInstance();

  constructor() {}

  isValidPhoneNumber(phoneNumber: string, country: string): boolean {
    try {
      const parsedNumber = this.phoneUtil.parseAndKeepRawInput(phoneNumber, country);
      return this.phoneUtil.isValidNumber(parsedNumber);
    } catch (error) {
      return false;
    }
  }

  getPhoneNumberMinLength(iso2: string): number {
    try {
      const exampleNumber: any = this.phoneUtil.getExampleNumberForType(iso2, PhoneNumberType.MOBILE);
      const formattedNumber = this.phoneUtil.format(exampleNumber, PhoneNumberFormat.NATIONAL);
      return formattedNumber.replace(/\D/g, '').length;
    } catch (error) {
      return 0;
    }
  }

  getPhoneNumberPlaceholder(iso2: string): string {
    try {
      const exampleNumber = this.phoneUtil.getExampleNumberForType(iso2, PhoneNumberType.MOBILE);
      const placeholder = this.phoneUtil.format(exampleNumber, PhoneNumberFormat.INTERNATIONAL);
      const splitedPlaceholder = placeholder.split(' ');
      splitedPlaceholder.shift(); // Exclude the country code
      return splitedPlaceholder.join(' ').replace(/-/g, ' ');
    } catch (error) {
      console.error('Error getting example number:', error);
      return '';
    }
  }
}
